//import fetch from "isomorphic-fetch";
import cookies from "js-cookie";

/// set cookies
export const setCookies = (key, value) => {
  let domain = "localhost";
  if (window.location.hostname != "localhost") {
    domain = window.location.hostname.substring(
      window.location.hostname.lastIndexOf(
        ".",
        window.location.hostname.lastIndexOf(".") - 1
      ) + 1
    );
  }
  if (typeof window !== "undefined") {
    cookies.set(key, value, {
      expires: 7,
      path: "/",
      domain: domain,
    });
  }
};

////remove cookies

export const removeCookies = (key) => {
  let domain = "localhost";
  if (window.location.hostname != "localhost") {
    domain = window.location.hostname.substring(
      window.location.hostname.lastIndexOf(
        ".",
        window.location.hostname.lastIndexOf(".") - 1
      ) + 1
    );
  }
  if (typeof window !== "undefined") {
    cookies.remove(key, {
      expires: 7,
      path: "/",
      domain: domain,
    });
  }
};

////get cookies

export const getCookie = (key) => {
  if (typeof window !== "undefined") {
    return cookies.get(key);
  }
};

/// set localStorage

export const setLocalStorage = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

///remove localStorage

export const removeLocalStorage = (key) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};

///authenticate user by pass data to cookies and localstorage

export const authenticate = (data, next) => {
  setCookies("token", data.token);
  setLocalStorage("user", data.user);
  next();
};

export const isAuth = () => {
  if (typeof window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      console.log(`cookieChecked`, cookieChecked);
      //   const storage = localStorage.getItem("persist:sourcingroot");
      //   if (storage != null) {
      //     const data = JSON.parse(storage);
      //     const auth = JSON.parse(data.auth);
      //         if(auth.isAuthenticated)
      //   }
      return true;
    } else {
      return false;
    }
  }
};
// export const isAuth = () => {
//   if (process.browser) {
//     const cookieChecked = getCookie("token");
//     if (cookieChecked) {
//       if (localStorage.getItem("user")) {
//         return JSON.parse(localStorage.getItem("user"));
//       } else {
//         return false;
//       }
//     }
//   }
// };
